class YarnRootSiteNav extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('toggle', (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
      if (details.open) {
        for (const sibling of this.querySelectorAll('details[open]')) {
          if (sibling !== details && !sibling.contains(details) && !details.contains(sibling)) sibling.open = false;
        }
      }
    }, { ...options, capture: true });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const details = event.target.closest('details[open]') || this.querySelector('details[open]');
      if (!details) return;
      event.preventDefault();
      event.stopPropagation();
      details.open = false;
      details.querySelector(':scope > summary')?.focus();
    }, options);
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.closeAll();
    }, options);
    this.addEventListener('focusout', (event) => {
      if (event.relatedTarget && !this.contains(event.relatedTarget)) this.closeAll();
    }, options);
    window.addEventListener('pageshow', () => this.closeAll(), options);
  }
  closeAll() {
    for (const details of this.querySelectorAll('details[open]')) details.open = false;
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('yr-site-nav')) customElements.define('yr-site-nav', YarnRootSiteNav);
